import { Component } from "@angular/core";

@Component({
  selector: "app-pi-indicador-flujo",
  templateUrl: "./pi-indicador-flujo.component.html",
  styleUrls: ["./pi-indicador-flujo.component.scss"],
  standalone: true,
})
export class PiIndicadorFlujoComponent {}
